
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mendable-api/manage-data-sources",
      function () {
        return require("private-next-pages/mendable-api/manage-data-sources.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mendable-api/manage-data-sources"])
      });
    }
  